import Vue from 'vue'
import axios from 'axios'
import router from '../router'
import store from '../store'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_HOST
})

axiosInstance.interceptors.request.use((config) => {
  if (store.state.token) {
    config.headers.Authorization = `Bearer ${store.state.token}`
  }

  return config
}, (err) => {
  return Promise.reject(err)
})

axiosInstance.interceptors.response.use((response) => {
  return response
}, (err) => {
  if (err.response && err.response.status === 401) {
    store.commit('LOGOUT')
    router.push('/login')
  }

  Vue.toasted.error(err.response.data.message, {
    icon: 'mdi-alert-circle'
  }).goAway(10000)

  return Promise.reject(err)
})

Vue.http = Vue.prototype.$http = axiosInstance
